import styled from "styled-components";

export const Wrapper = styled.div`
  min-width: 21.875rem;
  margin-right: 1rem;
  background-color: var(--black-200);
  border-radius: 4px;
  padding: 1rem;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const Header = styled.div`
  margin-bottom: 1rem;

  p {
    font-family: DM Sans;
    font-size: 1.25rem;
    margin: 0;
  }

  span {
    color: var(--grey-100);
    font-family: Inter;
    font-size: 0.8rem;
  }
`;
